/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './Login';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import SetPassword from './SetPassword';
import RedirectToLoginPreservingNext from '../components/RedirectToLoginPreservingNext';

export function AuthRoutes() {
  return (
    <Routes>
      <Route path="" element={<Login />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="signup" element={<Navigate to="/sign-up" replace />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="*" element={<RedirectToLoginPreservingNext />} />
    </Routes>
  );
}
